// extracted by mini-css-extract-plugin
module.exports = {"content":"_7a3fb80146--content--_Bi5x","icon-wrapper":"_7a3fb80146--icon-wrapper--Unje4","heading":"_7a3fb80146--heading--IqiYP","footer":"_7a3fb80146--footer--M5UrR"};